import TaskOutlined from "@mui/icons-material/TaskOutlined";
import { usePendingReviewCount } from "../../../pages/reviews/hooks/use-pending-review-count";
import { useFlag } from "../../../server/optimizely";
import { HeaderCount } from "./header-count";

import type { FC } from "react";

/**
 * Communications awaiting the user's approval, as the sidebar's Approvals badge counts them. Hidden
 * unless approvals are switched on, and if the reviews fail to load.
 */
export const PendingApprovalsCount: FC = () => {
  const [reviewEnabled] = useFlag("reviewer_role");
  const { data, error } = usePendingReviewCount(reviewEnabled);

  if (!reviewEnabled || error) return null;

  return (
    <HeaderCount
      icon={<TaskOutlined fontSize="small" />}
      to="/reviews"
      count={data}
      noneTooltip="No approval requests"
      someTooltip="You've been asked to approve Communications"
    />
  );
};
